export function validateClaim(data) {
  if (data.type === null || data.type === undefined) {
    return 'validation.claim.typeNull';
  }

  return '';
}
